import { forwardRef, type ComponentType } from 'react';
import {
  Box as MuiBox,
  Grid as MuiGrid,
  Stack as MuiStack,
  Typography as MuiTypography,
} from '@mui/material';

const systemKeys = [
  'alignItems',
  'alignSelf',
  'display',
  'flex',
  'flexShrink',
  'flexWrap',
  'fontFamily',
  'fontSize',
  'fontWeight',
  'gap',
  'gridTemplateColumns',
  'height',
  'justifyContent',
  'letterSpacing',
  'lineHeight',
  'm',
  'margin',
  'maxWidth',
  'mb',
  'minHeight',
  'minWidth',
  'ml',
  'mr',
  'mt',
  'mx',
  'my',
  'overflow',
  'overflowX',
  'p',
  'padding',
  'pb',
  'pl',
  'pr',
  'pt',
  'px',
  'py',
  'textAlign',
  'textTransform',
  'width',
] as const;

function withSystemProps(Component: ComponentType<any>) {
  return forwardRef<unknown, Record<string, any>>(function SystemPropsAdapter(props, ref) {
    const rest = { ...props };
    const system: Record<string, unknown> = {};
    for (const key of systemKeys) {
      if (key in rest) {
        system[key] = rest[key];
        delete rest[key];
      }
    }
    const sx = rest.sx;
    delete rest.sx;
    return <Component ref={ref} {...rest} sx={[system, ...(Array.isArray(sx) ? sx : [sx])]} />;
  });
}

export const Box = withSystemProps(MuiBox);
export const Grid = withSystemProps(MuiGrid);
export const Stack = withSystemProps(MuiStack);
export const Typography = withSystemProps(MuiTypography);
